import { useState } from 'react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'
import app, { FlashType } from 'modules/core/store/models/app'

import type Employee from '../store/models/Employee'

const showFlashMessage = (type: FlashType, message: string) => {
  app.setFlash({
    type,
    message,
  })
}

export const useSendInvitation = (employee: Employee) => {
  const [invitationSent, setInvitationSent] = useState(false)
  const [invitationSentToUsers, setInvitationSentToUsers] = useState<number[]>([])

  useEffect(() => {
    setInvitationSent(false)
  }, [employee.id])

  const { running, performAction } = useAsyncAction(async () => {
    const api = ApiClient()

    try {
      await api.post('/invitations', {
        access_id: employee.attributes.access_id,
      })

      setInvitationSent(true)
      setInvitationSentToUsers([...invitationSentToUsers, employee.attributes.access_id])

      showFlashMessage('correct', i18n.t('employees.invitation_sent'))
    } catch (error) {
      if (typeof error !== 'object' || error === null) {
        throw error
      }

      const errors = JSON.parse(JSON.stringify(error))

      if (!('payload' in errors) || !('messages' in errors.payload)) {
        throw error
      }

      const errorMessage = errors.payload.messages

      showFlashMessage('wrong', errorMessage)
    }
  })

  return {
    invitationSent,
    invitationSentToUsers,
    running,
    performAction,
  }
}
